import Link from "next/link";
import { ScrollShadow } from "@nextui-org/react";
import { BiBell, BiRightArrowAlt } from "react-icons/bi";

export default function NotificationList({
    items = [],
    width = "w-full",
    maxWidth = "",
    useScroll = false,
    scrollHeight = "350px",
    headerTitle = "THÔNG BÁO",
    showFooter = true,
    footerLink = "/chuyen-muc/thong-bao",
    footerText = "Xem tất cả",
    className = ""
}) {
    const containerClasses = [
        typeof width === 'string' && width.startsWith('w-') ? width : '',
        maxWidth,
        "bg-white rounded-lg shadow-lg overflow-hidden",
        className
    ].filter(Boolean).join(' ');

    const containerStyles = {};
    if (typeof width === 'string' && !width.startsWith('w-')) {
        containerStyles.width = width;
    }

    const NotificationItem = ({ notification, isLast }) => (
        <Link href={notification.link} className="group block">
            <div className={`${!isLast ? 'pb-4 border-b border-gray-200' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-semibold text-primary">
                        {notification.category}
                    </span>
                    <span className="text-xs text-gray-500">
                        {notification.date}
                    </span>
                </div>
                <h3 className="text-sm font-medium text-gray-800 leading-tight group-hover:text-blue-600 transition-colors">
                    {notification.title}
                </h3>
            </div>
        </Link>
    );

    return (
        <div className={containerClasses} style={Object.keys(containerStyles).length > 0 ? containerStyles : undefined}>
            <div className="px-6 py-4 flex items-center gap-3 bg-primary">
                <BiBell className="text-white text-2xl" />
                <h2 className="text-white text-xl font-bold uppercase tracking-wide">{headerTitle}</h2>
            </div>

            {useScroll ? (
                <ScrollShadow hideScrollBar className="p-4" style={{ height: scrollHeight }}>
                    <div className="space-y-4">
                        {items.map((notification, index) => (
                            <NotificationItem key={notification.id} notification={notification} isLast={index === items.length - 1} />
                        ))}
                    </div>
                </ScrollShadow>
            ) : (
                <div className="p-4 space-y-4">
                    {items.map((notification, index) => (
                        <NotificationItem key={notification.id} notification={notification} isLast={index === items.length - 1} />
                    ))}
                </div>
            )}

            {showFooter && (
                <div className="flex items-center justify-center px-4 pb-4 pt-2">
                    <Link href={footerLink} className="text-sm text-primary inline-flex items-center justify-center gap-1 transition-colors group font-medium">
                        <span>{footerText}</span>
                        <BiRightArrowAlt className="text-xl group-hover:translate-x-1 transition-transform" />
                    </Link>
                </div>
            )}
        </div>
    );
}
